import React, { Component } from "react";
import { Checkbox } from "antd";

import "./index.less";

export default class DataCheckbox extends Component {

  state = {
    loading: true,
  };

  options = [];

  componentDidMount() {
    this.load();
  };

  load = () => {
    this.props.onLoad().then(options => {
      this.options = options.map(item => ({
        label: item.label,
        value: item.value,
      }));
      this.setState({
        ...this.state,
        loading: false,
      });
    });
  };

  getOptions = () => {
    let options = this.options;
    const { filter, } = this.props;
    if (filter) {
      const isArray = Array.isArray(filter);
      options = options.filter(item => {
        const { value } = item;
        return isArray ? filter.includes(value) : filter(value, item);
      });
    }
    return options;
  };

  getValue = () => {
    let { value, } = this.props;
    value = String(value || "");
    return value.split(",").map(v => v.trim()).filter(v => v);
  };

  onChange = (values = []) => {
    const value = values.join(",");
    this.props.onChange && this.props.onChange(value)
  };

  render() {
    return (
      <Checkbox.Group
        {...this.props}
        value={this.getValue()}
        options={this.getOptions()}
        onChange={this.onChange}
      />
    );
  };
};
